<template>
  <v-card tile outlined style="min-height: 100%">
    <v-card-title class="pb-0">
      <v-row>
        <v-col cols="10">
          <router-link
            :to="{
              name: 'tasklist',
              params: { task_list_id: taskList.id }
            }"
          >
            {{ taskList.title }}
          </router-link>
        </v-col>

        <v-col align="right" cols="2">
          <v-btn icon @click="confirmDelete(taskList.id)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-text>
      <project-tasks :tasks="taskList.tasks" :showCompleted="showCompleted" />

      <v-expand-transition mode="out-in">
        <v-card class="mt-4" outlined v-if="showForm">
          <v-card-text>
            <task-create-form :taskList="taskList" @cancel="showForm = false" />
          </v-card-text>
        </v-card>
      </v-expand-transition>

      <v-row class="mt-3" align="center">
        <v-col>
          <v-fade-transition mode="out-in">
            <v-btn
              depressed
              color="secondary"
              v-if="!showForm"
              @click="showForm = true"
              small
            >
              <v-icon left>mdi-plus</v-icon>
              Add task
            </v-btn>
          </v-fade-transition>
        </v-col>

        <v-col align="right" v-if="completedTasksCount">
          <v-btn
            text
            color="secondary"
            @click="showCompleted = !showCompleted"
            small
          >
            {{ showCompleted ? 'Hide ' : 'Show ' }}
            {{ completedTasksCount }} completed tasks
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import ProjectTasks from './ProjectTasks'
import TaskCreateForm from '../common/TaskCreateForm'
import { mapActions } from 'vuex'
import { alertConfirm } from '@/utilities/sweetalert'

export default {
  name: 'ProjectTaskList',
  props: {
    taskList: {
      type: Object,
      required: true
    }
  },
  components: {
    ProjectTasks,
    TaskCreateForm
  },
  data: () => ({
    showForm: false,
    showCompleted: false
  }),
  computed: {
    completedTasksCount() {
      return this.taskList.tasks.filter(task => task.completed).length
    }
  },
  methods: {
    ...mapActions('taskLists', ['deleteTaskList']),
    confirmDelete(id) {
      alertConfirm(
        {
          title: 'Are you sure you want to delete this task list?',
          text: 'All tasks under this will be deleted as well.'
        },
        () => this.deleteTaskList(id)
      )
    }
  }
}
</script>
